export default __webpack_public_path__ + "static/media/explore-iv-banner-2@2x.a4fd5c33.png";